<template>
  <div>
    <h3>Summer Pay Requests</h3>

    <b-alert show>
      Review pending and completed summer pay requests.
    </b-alert>

    <b-form inline class="mb-2">
      <b-input-group class="filter-group">
        <b-input-group-prepend is-text>
          <font-awesome-icon icon="search" />
        </b-input-group-prepend>
        <b-form-input v-model="filter" placeholder="Type to Search" debounce="500"></b-form-input>
        <b-input-group-append>
          <b-button @click="filter = null">Clear</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form>

    <b-table striped
             hover
             :items="payRequests"
             :fields="fields"
             :per-page="perPage"
             :current-page="currentPage"
             sort-by="term.description"
             sort-desc
             :filter="filter"
             :filter-function="filterItems"
             @filtered="onFiltered"
             responsive
             show-empty>
      <!-- <template v-slot:cell(createdBy)="data">
        {{ data.item.employee.fullName}} 
      </template> -->
      <!-- <template v-slot:cell(termDescription)="data">
        {{ data.item.term.description}}
      </template> -->

      <template v-slot:cell(currentStatus.statusName)="data">
        <!-- Dec. 13, 2021: Add a sanity check and don't use statuses[0] -->
        {{ data.item.currentStatus ? data.item.currentStatus.statusName : "" }}
        <!-- {{ data.item.statuses[0].statusName }} -->
      </template>
      <template v-slot:cell(createdDate)="data">
        {{ data.item.createdDate | formatDate }}
      </template>
      <template v-slot:cell(details)="data">
        <router-link :to="{ name: 'payRequestDetails', params: { id: data.item.id } }">Details</router-link>
      </template>

    </b-table>

    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />
  </div>
</template>

<script>
import payRequestApi from "../../api/summerPayRequests";
import roleChecks from "../../misc/role-checks";

export default {
  mixins: [roleChecks],

  data() {
    return {
      filter: null,
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      fields: [
        {
          // Yeah, it sorts, just not actual values - not Faculty alphabetically or date numerically, it sorts by internal db ID
          key: "term.description",
          sortable: true,
          label: "Semester"
        },
        { key: "employee.fullName", sortable: true, label: "Faculty" },
        { key: "piEmployee.fullName", sortable: true, label: "PI" },          // added Dec. 2021
        { key: "createdDate", sortable: true, label: "Date Submitted" },
        { key: "currentStatus.statusName", sortable: true, label: "Status" },   // a little tip: deleting 'statusName' prints the details of the request
        { key: "details", label: "" }
      ],
      payRequests: [],
      sprHistory: null
    };
  },
  methods: {
    filterItems(dataObject) {
      var matchedFilter = this.matchFilter(dataObject, this.filter);

      if (matchedFilter) {
        return true;
      }
      return false;
    },

    matchFilter(item, filter) {
      if (filter != "" && filter != null) {
        var found = this.search([item], this.filter);
        return found.length > 0;
      }
      return true;
    },

    // Edit Dec. 2021 - remove and replace:

    // search(collection, text) {
    //   var that = this;
    //   return _.filter(collection, function(object) {
    //     var search = that.deepSearch(object, text.toLowerCase());
    //     return _.keys(search).length > 0;
    //   });
    // },

    search(collection, text) {
      return _.filter(collection, (object) => {
        var search = this.deepSearch(object, text.toLowerCase());
        return _.keys(search).length > 0;
      });
    },
    deepSearch(collection, predicate, thisArg) {
      if (_.isFunction(predicate)) {
        predicate = _.iteratee(predicate, thisArg);
      } else {
        var keys = _.flatten(_.tail(arguments));
        if (typeof keys === "string") {
          keys = keys.toLowerCase();
        }
        predicate = function(val) {
          if (typeof val === "string") {
            val = val.toLowerCase();
          }
          return _.includes(val, keys);
        };
      }
      var that = this;
      return _.transform(collection, function(memo, val, key) {
        var include = predicate(val, key);
        if (!include && _.isObject(val)) {
          val = that.deepSearch(val, predicate);
          include = !_.isEmpty(val);
        }
        if (include) {
          _.isArray(collection) ? memo.push(val) : (memo[key] = val);
        }
      });
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  },

  created() {
    payRequestApi
      .getActiveRequests(this.uid)
      .then(response => {
        this.payRequests = response.data;
        this.totalRows = this.payRequests.length;
      })
      .catch(function(error) {
        console.log("Error: ");
        console.log(error);
      });

      // do NOT place this line here!!!! It will be called with an empty ID each time any page loads
      // payRequestApi.submittedEmail(this.uid);
  }
};
</script>
